import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ContactForm from "@/pages/about/components/ContactForm";
import { teamMembers } from "@/mocks/team";

const positioningStats = [
  { value: "1,200+", label: "收录影视作品" },
  { value: "3,000+", label: "剧情解析文章" },
  { value: "50万+", label: "月均读者" },
  { value: "每日", label: "内容实时更新" },
];

const usageNotes = [
  {
    icon: "ri-information-line",
    title: "内容说明",
    text: "本站影视作品信息、评分与剧情介绍均为虚构示例，仅用于内容展示与演示用途，不代表任何真实作品。",
  },
  {
    icon: "ri-copyright-line",
    title: "版权与转载",
    text: "站内原创解析文章归本站所有，转载请注明出处。如涉及版权问题，请通过联系表单与我们取得联系。",
  },
  {
    icon: "ri-bookmark-line",
    title: "收藏功能",
    text: "收藏功能仅在当前浏览器本地保存，用于标记感兴趣的作品，不会上传到服务器，也无需登录。",
  },
  {
    icon: "ri-share-line",
    title: "分享说明",
    text: "分享按钮仅复制当前页面链接，便于你分享给朋友，不会调用任何第三方分享接口。",
  },
  {
    icon: "ri-user-heart-line",
    title: "社区礼仪",
    text: "欢迎理性讨论剧情与角色。请勿发布违规、攻击性内容，共同维护良好的影迷交流氛围。",
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 - 肮脏的交易影视资讯"
        description="了解肮脏的交易影视资讯与剧情解析平台：我们的网站定位、团队简介、联系方式与用户使用须知。"
        keywords="关于我们,肮脏的交易,影视资讯,剧情解析,联系我们"
      />

      <section className="w-full border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-12">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
            关于肮脏的交易
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            我们是一个专注影视作品资讯与剧情解析的门户平台，希望用专业、详尽而易于阅读的内容，帮助每一位影迷更深入地理解影视作品。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="mb-3 inline-block rounded-md bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              网站定位
            </span>
            <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">
              让每一次观影，都变成一次真正的理解
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              肮脏的交易覆盖电影与电视剧两大类内容，提供权威、详尽且易阅读的影视资讯与剧情解析。我们不仅告诉影迷一部作品讲了什么，更希望帮助他们理解作品为何动人。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              从剧情脉络的梳理，到角色动机的剖析，再到视听语言的解读，我们始终坚持内容严谨、表达亲和，力求让不同观影经验的读者都能读得懂、读得下去。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {positioningStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-50 p-5 text-center md:p-7"
              >
                <p className="text-2xl font-bold text-primary-600 md:text-3xl">{stat.value}</p>
                <p className="mt-2 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-10 md:py-14">
        <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
          <span className="mb-3 inline-block rounded-md bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            团队简介
          </span>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">我们的编辑团队</h2>
          <p className="mt-3 max-w-3xl text-sm text-foreground-600 md:text-base">
            团队成员均具备多年影视内容从业经验，负责资讯采集、剧情解析撰写与内容审核，确保每一条内容专业可靠。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {teamMembers.map((member, index) => (
              <div
                key={member.name}
                className="flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-6 text-center"
              >
                <span
                  className={`flex h-16 w-16 items-center justify-center rounded-full text-2xl font-bold text-background-50 ${
                    index % 2 === 0 ? "bg-primary-600" : "bg-accent-500"
                  }`}
                >
                  {member.name.slice(0, 1)}
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">{member.name}</h3>
                <p className="mt-1 text-xs text-primary-600">{member.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] lg:gap-12">
          <div>
            <span className="mb-3 inline-block rounded-md bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              联系方式
            </span>
            <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">联系我们</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              如果你有内容建议、纠错反馈或合作意向，欢迎通过以下方式与我们取得联系。
            </p>
            <ul className="mt-6 flex flex-col gap-4">
              <li className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-mail-line text-lg" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-950">电子邮箱</p>
                  <p className="mt-1 text-sm text-foreground-600">contact@dirtydeal-media.com</p>
                </div>
              </li>
              <li className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-map-pin-line text-lg" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-950">办公地址</p>
                  <p className="mt-1 text-sm text-foreground-600">
                    北京市朝阳区文化创意园 A 座 12 层
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <ContactForm />
        </div>
      </section>

      <section className="w-full bg-background-100 py-10 md:py-14">
        <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">用户使用须知</h2>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {usageNotes.map((note) => (
              <div
                key={note.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className={`${note.icon} text-lg`} />
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-950">{note.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{note.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}